import React from "react";

export function UserIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
    >
      <g data-name="Group 4283" transform="translate(13356 -11940)">
        <g
          data-name="Ellipse 144"
          transform="translate(-13356 11940)"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
        >
          <circle cx="22" cy="22" r="22" stroke="none" />
          <circle cx="22" cy="22" r="21" fill="none" />
        </g>
        <g data-name="Group 3721" transform="translate(-13346.104 11947.719)">
          <path
            data-name="Path 2073"
            d="M14.371,0c.282.058.569.1.845.177a6.781,6.781,0,0,1,5.236,5.456,6.879,6.879,0,0,1-4.788,8.038A7,7,0,0,1,11.474.312,11.365,11.365,0,0,1,12.631.06c.071-.016.14-.04.21-.06Zm4.5,6.989a5.28,5.28,0,1,0-5.282,5.28,5.262,5.262,0,0,0,5.282-5.28"
            transform="translate(-1.679 0)"
            fill="#fff"
            stroke="#fff"
            strokeWidth="0.5"
          />
          <path
            data-name="Path 2074"
            d="M12.081,33.8c-2.4,0-4.8.013-7.2,0a4.927,4.927,0,0,1-3.367-1.255,4.214,4.214,0,0,1-1.445-2.8,15.136,15.136,0,0,1,.953-7.05,5.971,5.971,0,0,1,2.661-3.23,5.307,5.307,0,0,1,2.661-.651,2.012,2.012,0,0,1,.868.294c.43.233.831.52,1.245.782a6.606,6.606,0,0,0,4.1,1.108,6.792,6.792,0,0,0,3.052-1.023,8.569,8.569,0,0,0,.947-.617,2.769,2.769,0,0,1,2.519-.426,5.422,5.422,0,0,1,3.7,2.907,11.112,11.112,0,0,1,1.233,4.114,28.83,28.83,0,0,1,.174,3.189,4.581,4.581,0,0,1-3.815,4.542,7.533,7.533,0,0,1-1.32.119c-2.323.011-4.646.005-6.969.005Zm.027-1.7H14.77c1.482,0,2.966.025,4.447-.011a3.041,3.041,0,0,0,3.273-3.409,23.353,23.353,0,0,0-.172-2.51,9.7,9.7,0,0,0-1.049-3.525,3.766,3.766,0,0,0-2.476-2.033,1.454,1.454,0,0,0-1.382.225,6.476,6.476,0,0,1-.78.511,8.025,8.025,0,0,1-8.153.5c-.7-.338-1.341-.8-2.012-1.2a.663.663,0,0,0-.336-.113,3.366,3.366,0,0,0-2.5,1.131,6.5,6.5,0,0,0-1.307,2.448,16.074,16.074,0,0,0-.615,4.72,2.954,2.954,0,0,0,1.648,2.9,4.184,4.184,0,0,0,1.9.367q3.428,0,6.855,0"
            transform="translate(0 -4.789)"
            fill="#fff"
            stroke="#fff"
            strokeWidth="0.5"
          />
          <path
            data-name="Path 2075"
            d="M19.458,7.57a5.28,5.28,0,1,1-5.279-5.288A5.259,5.259,0,0,1,19.458,7.57"
            transform="translate(-2.266 -0.581)"
            fill="none"
            stroke="#fff"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </svg>
  );
}
